import z from "zod";

export const envSchema = z.object({
  VITE_SERVER_URL: z.url(),
  VITE_GOOGLE_MAPS_API_KEY: z.string(),
  VITE_MAP_ID: z.string(),
  VITE_MEDIA_URL: z.url(),
});

export const env = envSchema.parse(import.meta.env);
